import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";

import {
  getCad3dSettingsAdmin,
  patchCad3dSettingsAdmin,
  type Cad3dSettingsAdmin,
  type UpdateCad3dSettingsAdminBody,
} from "../api/cad3dAdmin";

const KEY = "cad3d-settings-admin";

export function useCad3dSettingsAdmin(enabled = true) {
  return useQuery<Cad3dSettingsAdmin>({
    queryKey: [KEY],
    queryFn: getCad3dSettingsAdmin,
    enabled,
    staleTime: 30_000,
  });
}

export function useUpdateCad3dSettingsAdmin() {
  const queryClient = useQueryClient();
  return useMutation<Cad3dSettingsAdmin, Error, UpdateCad3dSettingsAdminBody>({
    mutationFn: patchCad3dSettingsAdmin,
    onSuccess: (result) => {
      queryClient.setQueryData([KEY], result);
      void queryClient.invalidateQueries({ queryKey: [KEY] });
    },
  });
}
